module.exports = __webpack_public_path__ + "static/media/Argos.29c697b8.png";